import React from 'react';
import { Card, Skeleton, Avatar, List, Tag } from 'antd';
import { MessageSquare } from 'lucide-react';
import { RecentConversationItem } from '../../services/dashboardService';
import { Link } from 'react-router-dom';

interface RecentConversationsProps {
    data: RecentConversationItem[];
    loading?: boolean;
}

const RecentConversations: React.FC<RecentConversationsProps> = ({ data, loading }) => {
    return (
        <Card
            title={<span style={{ fontWeight: 600 }}>最近对话</span>}
            extra={<Link to="/admin/conversations">查看全部 →</Link>}
            variant="borderless"
            style={{ borderRadius: 12, height: '100%', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}
            styles={{ body: { padding: '12px 24px' } }}
        >
            <Skeleton loading={loading} active paragraph={{ rows: 5 }}>
                <List
                    itemLayout="horizontal"
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item style={{ padding: '12px 0', borderBottom: '1px solid #F4F4F5', borderBlockEnd: '1px solid #F4F4F5' }}>
                            <List.Item.Meta
                                avatar={
                                    <Avatar style={{ backgroundColor: item.avatar_color, color: '#2563EB' }} icon={<MessageSquare size={16} />} />
                                }
                                title={
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 500, color: '#18181B' }}>{item.user_name}</span>
                                        <span style={{ color: '#A1A1AA', fontSize: 12, fontWeight: 400 }}>{item.time}</span>
                                    </div>
                                }
                                description={
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 4 }}>
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                                            <Tag color="blue" bordered={false} style={{ margin: 0, borderRadius: 4, flexShrink: 0 }}>{item.intent}</Tag>
                                            <span style={{
                                                color: '#71717A',
                                                fontSize: 13,
                                                overflow: 'hidden',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical' as const,
                                                wordBreak: 'break-all',
                                                lineHeight: '1.5',
                                            }}>
                                                {item.message}
                                            </span>
                                        </div>
                                    </div>
                                }
                            />
                        </List.Item>
                    )}
                />
                {data.length === 0 && !loading && (
                    <div style={{ textAlign: 'center', color: '#A1A1AA', padding: '20px 0' }}>暂无对话记录</div>
                )}
            </Skeleton>
        </Card>
    );
};

export default RecentConversations;
